__webpack_require__.p = "/colors-remapping-clean-up/referrals/";